<div
  mat-dialog-title
  [class.justify-content-between]="dowloadedDocuments()"
  [class.justify-content-center]="!dowloadedDocuments()">
  @if (dowloadedDocuments()) {
    <button type="button" mat-icon-button (click)="clearDocuments()">
      <ft-icon name="arrow-left" class="ft-icon--2" />
    </button>
  }
  @switch (mode()) {
    @case ('share') {
      <ng-container i18n>Share PDF</ng-container>
    }
    @case ('download') {
      <ng-container i18n>Download PDF</ng-container>
    }
  }
  @if (dowloadedDocuments()) {
    <div style="width: 40px; height: 40px; margin-right: -2.5rem"></div>
  }
</div>
<form
  id="form"
  class="pb-0"
  [formGroup]="form"
  (ngSubmit)="submit()"
  #contentElement
  mat-dialog-content>
  @if (dowloadedDocuments() && mode() === 'share') {
    <p i18n>Document(s) selected to share:</p>
    <div class="d-flex flex-column gap-2 my-4">
      @if (form.get('creditDetail')?.value) {
        <div class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Loan details</div>
        </div>
      }
      @if (form.get('payments')?.value) {
        <div class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Registered payments (account statement)</div>
        </div>
      }
      @if (form.get('supportDoc')?.value) {
        <div class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Supporting document</div>
        </div>
      }
    </div>
  } @else if (dowloadedDocuments() && mode() === 'download') {
    <p i18n>Please click on document you wish to download:</p>
    <div class="d-flex flex-column gap-2 my-4">
      @if (form.get('creditDetail')?.value) {
        <a
          [href]="documentsDownload().creditDetail"
          [download]="loanDetails + '-' + (credit()?.operationNumber || credit()?.operation?.number)"
          class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Loan details</div>
        </a>
      }
      @if (form.get('payments')?.value) {
        <a
          [href]="documentsDownload().payments"
          [download]="registeredPayments + '-' + (credit()?.operationNumber || credit()?.operation?.number)"
          class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Registered payments (account statement)</div>
        </a>
      }
      @if (form.get('supportDoc')?.value) {
        <a
          [href]="documentsDownload().supportDoc"
          [download]="supportingDocument + '-' + (credit()?.operationNumber || credit()?.operation?.number)"
          class="d-flex gap-2 align-items-center">
          <ft-icon
            name="document--text"
            class="ft-icon--3"
            collection="factoricons-slim" />
          <div i18n>Supporting document</div>
        </a>
      }
    </div>
  } @else {
    @if (mode() === 'share') {
      <p i18n>Please select the documents you wish to share:</p>
    } @else {
      <p i18n>Please select the documents you wish to download:</p>
    }
    <div class="d-flex flex-column">
      <mat-checkbox formControlName="creditDetail" i18n>Loan details</mat-checkbox>
      <mat-checkbox formControlName="payments" i18n>Registered payments (account statement)</mat-checkbox>
      <mat-checkbox formControlName="supportDoc" i18n>Supporting document</mat-checkbox>
    </div>
  }
</form>
<div #actionsElement class="justify-content-center" mat-dialog-actions>
  <button
    type="button"
    mat-stroked-button
    [disabled]="sharing() || submitting()"
    mat-dialog-close
    i18n>Close</button>
  @if (dowloadedDocuments() && mode() === 'share') {
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="share()"
      [disabled]="sharing()">
      @if (!sharing()) {
        <div class="ft-item gap-2">
          <ft-icon name="share" class="ft-icon--2" />
          <div i18n>Share</div>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  } @else if (!dowloadedDocuments() || mode() === 'share') {
    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="download()"
      [disabled]="submitting()">
      @if (!submitting()) {
        <div i18n>Continue</div>
      } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  }
</div>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
